// eslint-disable-next-line no-magic-numbers -- [1, 2, 3] are the available price tiers, self-documenting
export const AVAILABLE_PRICE_TIERS = [1, 2, 3]
